import { CountrySlug } from './utils/locale';

export const Config = {
    environment: process.env.REACT_APP_ENVIRONMENT ?? '',
    version: process.env.REACT_APP_VERSION ?? '',

    baseUrlApi: process.env.REACT_APP_BASE_URL_API ?? '',
    baseUrlCdn: process.env.REACT_APP_BASE_URL_CDN ?? '',

    authApi: {
        sweden: process.env.REACT_APP_AUTH_API_URL_SE,
        norway: process.env.REACT_APP_AUTH_API_URL_NO,
        denmark: process.env.REACT_APP_AUTH_API_URL_DK,
        finland: process.env.REACT_APP_AUTH_API_URL_FI,
        germany: process.env.REACT_APP_AUTH_API_URL_DE,
    } as Record<CountrySlug, string>,
};
